export { default as BrowserBreakpoint } from './BrowserBreakpoint';
export { default as Desktop } from './Desktop';
export { default as Mobile } from './Mobile';

/**
 * Грязный хак для того чтоб в галерее компонентов появилась документация
 * по текущему компоненту.
 *
 * Хак заключается в том, что для вывода документации в корневом
 * компоненте (`index.js`) должен быть JSX по которому парсер галереи
 * компонентов определяет является ли модуль реактовским компонентом.
 */
// eslint-disable-next-line no-unused-vars
const exposeHack = <div />;
